/**
 * @created on 2018/10/22
 * @author zengshaopeng
 **/

import './index.scss'
import { axios as $http } from 'cm'
import api from './api'
import Bridge from '../../../frontend-lib/lib/Bridge'
import { wxConfigOrigin } from 'src/frontend-lib/tools/utils'
import { getEnvHost } from 'src/frontend-lib/tools/getPlatform'
import { GetRequest } from '../../../public-resource/libs/utils/index'
import { funFactory } from '../../../public-resource/libs/axios/requestSign'
import renderRankList from './render/rankList'

// import vconsole from 'vconsole'
// new vconsole()
;(function() {
  let gobackIcon = $('.yxl-font-back')

  gobackIcon.click(function() {
    window.history.back()
  })

  const IS_APP = window.$platform.isYixinliApp

  let myBrige = new Bridge()
  let token = ''

  if (IS_APP) {
    $('.nav-header').css('display', 'none')
    $('.container').css('padding-top', 0)
    myBrige.call('setTitle', { title: '回答者榜单' })
    myBrige.call('setConfig', { isAllowedTitleAnimate: 1 })
  }

  getToken()

  wxShareInit()

  window.yxl.stat.send({
    name: '问答-「回答者榜单」访问'
  })

  if (GetRequest().from === 'index-rank-tab') {
    window.history.pushState(null, '', api.rankList)
    window.toast('点击右上角，立即分享~')
  }

  $('.my-ques').on('click', function() {
    if (window.$platform.isWechat) {
      window.toast('请点击右上角分享给好友!')
    } else {
      let selection = window.getSelection() // Save the selection.
      let range = document.createRange()
      let $url = document.createElement('div')

      $url.display = 'none'
      // $url.innerHTML = $config.url;
      $url.innerHTML = window.location.href

      document.body.appendChild($url)

      range.selectNodeContents($url)
      selection.removeAllRanges() // Remove all ranges from the selection.
      selection.addRange(range) // Add the new range.

      document.execCommand('copy')

      selection = null
      range = null
      document.body.removeChild($url)

      window.toast('请点击右上角分享给好友!')
    }
  })

  function getToken() {
    if (IS_APP) {
      window.getTokenFn = function(obj) {
        let newObj = JSON.parse(obj)
        if (newObj.token) {
          token = newObj.token
        }
      }
      myBrige.call('getToken', { callbackName: 'getTokenFn' })
    } else {
      $http
        .get(api.isLogin)
        .then(res => res.data)
        .then(res => {
          if (+res.code === 0) {
            if (res.data.user && res.data.user.token) {
              token = res.data.user.token || ''
            }
          }
        })
    }
  }

  function loginJudment() {
    if (!token) {
      window.toast('检测到暂未登录,即将跳转到登录页面~')
      window.loginTimer = setTimeout(() => {
        window.location.href = api.login
      }, 2000)
      return
    }
  }

  function wxShareInit() {
    let title = window.baseInfo.wx_share.title // 分享标题
    let link = window.baseInfo.wx_share.url.replace(
      window.location.protocol + getEnvHost(`//m.xinli001.com`),
      wxConfigOrigin(
        require('../../../../yxlConfig.json'),
        'QA_ORIGIN',
        'm_safe'
      )
    ) // 分享链接
    let desc = window.baseInfo.wx_share.desc
    let imgUrl = window.baseInfo.wx_share.image // 分享图标

    if (window.$platform.isWechat) {
      let currentUrl = document.location.href
      let getWxConfig = api.getWXShareConfig
      $http
        .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
        .then(res => {
          if (res.data.code == 0) {
            var wxConfig = res.data.data

            function loadScript(url, callback) {
              var script = document.createElement('script')
              script.type = 'text/javascript'
              if (typeof callback !== 'undefined') {
                if (script.readyState) {
                  script.onreadystatechange = function() {
                    if (
                      script.readyState == 'loaded' ||
                      script.readyState == 'complete'
                    ) {
                      script.onreadystatechange = null
                      callback()
                    }
                  }
                } else {
                  script.onload = function() {
                    callback()
                  }
                }
              }
              script.src = url
              document.body.appendChild(script)
            }

            setTimeout(() => {
              loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
                var _config = {
                  debug: wxConfig.debug,
                  appId: wxConfig.appId,
                  timestamp: wxConfig.timestamp,
                  nonceStr: wxConfig.nonceStr,
                  signature: wxConfig.signature,
                  jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo',
                    'onMenuShareQZone',
                    'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                    'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
                  ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                }

                // 微信基本配置信息
                wx.config(_config)
                wx.ready(function() {
                  var shareConfig = {
                    title: title,
                    desc: desc,
                    link: link,
                    imgUrl: imgUrl,
                    success: function(res) {},
                    cancel: function(res) {},
                    fail: function(res) {}
                  }
                  // 分享到朋友圈
                  wx.onMenuShareTimeline(shareConfig)
                  // 分享给朋友
                  wx.onMenuShareAppMessage(shareConfig)
                  // 分享到QQ
                  wx.onMenuShareQQ(shareConfig)
                  // 分享到腾讯微博
                  wx.onMenuShareWeibo(shareConfig)
                  // 分享到QQ空间
                  wx.onMenuShareQZone(shareConfig)
                  wx.updateAppMessageShareData(shareConfig)
                  wx.updateTimelineShareData(shareConfig)
                })
              })
            }, 500)
          }
        })
    }
    if (IS_APP) {
      appShare(title, link, desc, imgUrl)
    }
  }

  function appShare(title, link, desc, imgUrl) {
    window.Bridge = Bridge

    window.myBrige = new Bridge({
      methods: [
        {
          method: 'topFuncBtn',
          callback(ops) {
            if (ops.name === 'shareReportBtn') {
              let $config = {
                title, // 分享标题
                link, // 分享链接
                desc,
                imgUrl // 分享图标
              }
              window.myBrige.call('shareReport', $config)
            }
          }
        }
      ]
    })

    window.myBrige.call('topFuncBtnConfig', {
      btnList: [
        {
          name: 'shareReportBtn',
          visible: 1
        }
      ]
    })
  }
  // let url = $('.rank-popular').attr('data-url')
  // if (url) {
  //   $http
  //     .get(url)
  //     .then(res => {
  //       $('.popular').append(res)
  //     })
  //     .catch(err => window.toast(err))
  // }

  $(document).delegate('.ques', 'click', function() {
    let url = window.location.protocol + api.postQuestion
    let id = $(this).attr('data-user_id')
    let name = $(this).attr('data-nickname')

    $http
      .get(api.getInviteNum)
      .then(res => res.data)
      .then(res => {
        if (+res.code === 0) {
          if (parseInt(res.data.invite_num) <= 0) {
            window.toast('你的问答邀请次数已用完,无法继续邀请~')
          } else {
            let storage = window.localStorage
            storage['invite_user'] = id
            window.yxl.stat.send({
              name: '问答-回答者榜单「向ta提问」点击',
              properties: {
                用户名: name
              }
            })
            if (IS_APP) {
              myBrige.call('openWebView', {
                url: url,
                isCurrentPageOpen: 0
              })
            } else {
              window.location.href = url
            }
          }
        }
      })
      .catch(err => window.toast(err))
  })

  $(document).delegate('.rank-attention', 'click', function(event) {
    event.preventDefault()

    loginJudment()

    let id = $(this).attr('data-user-id')
    let url
    if (IS_APP && token) {
      url = api.followAttention + '?user_id=' + id + '&token=' + token
    } else {
      url = api.followAttention + '?user_id=' + id
    }
    $http
      .get(url, {
        disabledUnLoginInterceptors: true
      })
      .then(res => {
        if (res.data.code === 40002) {
          window.toast(res.data.message)
          return
        }
        if (res.data.code === 0) {
          window.toast(res.data.message)
          $(this)
            .children('p')
            .toggle()
          if (res.data.data.is_follow === 1) {
            window.yxl.stat.send({
              name: '问答-交互行为',
              properties: {
                页面: '榜单页',
                行为: '点击',
                对象: '关注',
                咨询师: $(this)
                  .parents('.rank-item')
                  .attr('data-teacher'),
                id
              }
            })

            // 积分
            if (IS_APP) {
              const saveTask = funFactory(
                `${getEnvHost(
                  '//yiapi.xinli001.com'
                )}/v6/yi/integral/save-task.json`,
                'post'
              )
              saveTask({
                task_type: '3',
                task_action: 'follow_user',
                business: 'follow',
                business_id: id,
                token
              }).then(res => {
                const { message, code } = res
                if (code === 0 && message) {
                  myBrige.call('showMessage', {
                    content: message,
                    type: 'integral'
                  })
                }
              })
            }
          }
        }
      })
      .catch(err => {
        // window.toast(err)
        console.error(err)
        monitor.stat({
          level: 'error',
          error: 'api-data',
          msg: err,
          api: url,
          apiParams: JSON.stringify({
            disabledUnLoginInterceptors: true
          })
        })
      })
  })

  $(document).delegate('.rank-avatar, .rank-info-name', 'click', function(e) {
    e.preventDefault()

    let href =
      $(this).attr('href') ||
      $(this)
        .children('a')
        .attr('href')
    if (href === 'javascript:;' || !href) return

    window.yxl.stat.send({
      name: '问答-交互行为',
      properties: {
        页面: '榜单页',
        行为: '点击',
        对象: '用户头像',
        咨询师: $(this)
          .parents('.rank-item')
          .attr('data-teacher'),
        id: $(this)
          .parents('.rank-item')
          .attr('data-user-id')
      }
    })

    if (IS_APP) {
      window.myBrige.call('openWebView', {
        url: href,
        isCurrentPageOpen: 0
      })
    } else {
      window.open(href)
    }
  })

  // 选中卡的切换效果,顺带切换下面的榜单
  $('.rank-popular')
    .children('.title')
    .css('font-weight', 'bold')
  $('.rank-popular')
    .children('.month')
    .css('font-weight', 'bold')

  $('.rank').on('click', function(e) {
    $('.rank')
      .siblings()
      .children('div')
      .removeClass('active-section')
    $(e.currentTarget)
      .children('div')
      .addClass('active-section')
    $('.rank')
      .siblings()
      .children('.title')
      .css('font-weight', 'normal')
    $('.rank')
      .siblings()
      .children('.month')
      .css('font-weight', 'normal')
    $(this)
      .children('.title')
      .css('font-weight', 'bold')
    $(this)
      .children('.month')
      .css('font-weight', 'bold')
    // console.log($(e.currentTarget).attr('attr-id'))
    $('.content')
      .children('ul')
      .css('display', 'none')
    $('.' + $(e.currentTarget).attr('attr-id')).css('display', 'block')
    let type = $(this).attr('attr-id')
    let dataUrl = api.rankList
    let params = {
      format: 'json',
      is_ajax: 1
    }
    let isPopular
    switch (type) {
      case 'popular':
        isPopular = true
        if (IS_APP) {
          dataUrl += `?token=${token}`
        }
        params.type = 'most_popular'
        break
      case 'devote':
        isPopular = false
        params.type = 'most_contribute'
        break
      case 'essence':
        isPopular = false
        params.type = 'most_cream'
        break
      default:
        break
    }
    $http
      .get(dataUrl, {
        params
      })
      .then(res => res.data)
      .then(res => {
        if (+res.code === 0 && res.data && res.data.length) {
          $('.' + type).html('')
          $('.' + type).append(renderRankList(res.data, isPopular))
        }
      })
      .catch(err => window.toast(err))
  })

  let top = $('.rank-title').offset().top
  $(document).scroll(function() {
    if ($(document).scrollTop() > top + 40) {
      $('.rank-title').addClass('add-box-shadow')
      $('.rank-title').addClass('rank-fixed')
      if (!IS_APP) {
        $('.nav-header').css('display', 'none')
        $('.container').css('padding-top', 0)
      }
    }
    if ($(document).scrollTop() == 0) {
      $('.rank-title').removeClass('add-box-shadow')
      $('.rank-title').removeClass('rank-fixed')
      if (!IS_APP) {
        $('.nav-header').css('display', 'block')
        $('.container').css('padding-top', '1.22667rem')
      }
    }
  })
})()



// WEBPACK FOOTER //
// ./src/pages/ask/rankingList/index.js